<div class="design-container">
  <div class="design-preview-container">
    <div class="designer-video-wrapper">

      @if(store.videoConfig().videoEnabled) {
        <app-video-device-player
          [stream]="fakeRemoteStream()"
          deviceName="test"
          [isActive]="true"
          (playerClick)="onPlayerClick()"
        >
        </app-video-device-player>
      }
      </div>
      
    @for (row of store.rows(); track row.id; let rowIndex = $index) {
      <div
        (click)="handleRowClick(row.id)"
        class="cockpit-row"
        [style.margin-right.px]="row.properties.marginRight"
        [style.margin-left.px]="row.properties.marginLeft"
        [style.margin-top.px]="row.properties.marginTop"
        [style.margin-bottom.px]="row.properties.marginBottom"
        [style.padding-right.px]="row.properties.paddingRight"
        [style.padding-left.px]="row.properties.paddingLeft"
        [style.padding-top.px]="row.properties.paddingTop"
        [style.padding-bottom.px]="row.properties.paddingBottom"
        [style.height.px]="row.properties.height"
        [style.width]="`calc(100% - ${(+row.properties.marginLeft) + (+row.properties.marginRight)}px)`"
        [style.grid-template-columns]="'repeat(' + row.columns.length + ', 1fr)'"
      >
        @for (item of row.columns; track item.id; let i = $index) {
          <div class="grid-item" [style.grid-column]="i + 1 + ' / ' + (i + 2)">
            <app-cockpit-designer-component-wrapper
              [componentsList]="item.components"
              [cellId]="item.id"
              [rowId]="row.id"
              [columnIndex]="i"
              [columnId]="item.id"
              (onOpenSettings)="handleOpenUp($event, row.id, item.id)"
            >
            </app-cockpit-designer-component-wrapper>
          </div>
        }
      </div>
    }
  </div>
  <video
  #demoVideo
  src="/assets/testdronevideo.mp4"
  muted
  loop
  autoplay
  playsinline
  style="display:none">
</video>
  <div class="design-side-bar">
    <app-design-sidebar
     [selectedComponent]="selectedComponent()" 
     (closeComponentSettings)=onCloseComponentSettings() 
     (assignedDevicesChange)="onAssignedBotsChange($event)" 
     [devices]="devices" [components]="cockpitComponentsList" 
     (onSave)="handleSave()"
     (pushButtonIdChange)="handlePushButtonIdChange($event)"
     (pushButtonNameChange)="handlePushButtonNameChange($event)"
     (handleComponentChange)="componentChange($event)"
     > 
     

    </app-design-sidebar>
  </div>
</div>
